export const UNLEASH_CONFIG = {
  appName: 'job-portal-admin',
  refreshInterval: parseInt(
    process.env.NEXT_PUBLIC_UNLEASH_REFRESH_INTERVAL as string,
  ),
  url: `${process.env.NEXT_PUBLIC_APP_URL}/api/unleash/frontend`,
  clientKey: process.env.NEXT_PUBLIC_UNLEASH_FRONTEND_API_TOKEN as string,
};
